import type { MqttClient } from 'mqtt';

export enum MqttConnectionStatus {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  RECONNECTING = 'reconnecting',
  ERROR = 'error',
}

export enum MqttConnectionActionType {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  RECONNECT = 'reconnect',
  GET_CLIENT = 'getClient',
  ENSURE = 'ensure',
}

export type MqttConnectionAction =
  | { type: MqttConnectionActionType.CONNECT }
  | { type: MqttConnectionActionType.DISCONNECT; force?: boolean }
  | { type: MqttConnectionActionType.RECONNECT }
  | { type: MqttConnectionActionType.GET_CLIENT }
  | { type: MqttConnectionActionType.ENSURE };

export enum MqttInitializationStatus {
  IDLE = 'idle',
  INITIALIZING = 'initializing',
  INITIALIZED = 'initialized',
  ERROR = 'error',
}

export interface MqttMetadata {
  error?: Error;
  lastConnectedAt?: number;
  isInitializing?: boolean;
  connectionPromise?: Promise<MqttClient>;
}
